import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { OrderProvider } from './contexts/OrderContext';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
// Pages
import { LoginPage } from './pages/LoginPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { DriverDashboard } from './pages/DriverDashboard';
import { DepotDashboard } from './pages/DepotDashboard';
import { CreateOrderPage } from './pages/CreateOrderPage';
import { OrderListPage } from './pages/OrderListPage';
import { OrderDetailPage } from './pages/OrderDetailPage';
import { DepotReceptionPage } from './pages/DepotReceptionPage';
import { CleaningManagementPage } from './pages/CleaningManagementPage';
import { StorageAssignmentPage } from './pages/StorageAssignmentPage';
import { ConfirmCollectionPage } from './pages/ConfirmCollectionPage';
import { DriverToursPage } from './pages/DriverToursPage';
import { DriverTourDetailPage } from './pages/DriverTourDetailPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { TourManagementPage } from './pages/TourManagementPage';
export function App() {
  return <AuthProvider data-id="element-0">
      <OrderProvider data-id="element-1">
        <Router data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/login" element={<LoginPage data-id="element-5" />} data-id="element-4" />

            <Route path="/" element={<Layout data-id="element-7">
                  <Navigate to="/login" replace data-id="element-8" />
                </Layout>} data-id="element-6" />

            {/* Admin Routes */}
            <Route path="/admin" element={<ProtectedRoute allowedRoles={['ADMIN']} data-id="element-10">
                  <Layout data-id="element-11">
                    <AdminDashboard data-id="element-12" />
                  </Layout>
                </ProtectedRoute>} data-id="element-9" />
            <Route path="/orders/new" element={<ProtectedRoute allowedRoles={['ADMIN']} data-id="element-14">
                  <Layout data-id="element-15">
                    <CreateOrderPage data-id="element-16" />
                  </Layout>
                </ProtectedRoute>} data-id="element-13" />
            <Route path="/users" element={<ProtectedRoute allowedRoles={['ADMIN']} data-id="element-18">
                  <Layout data-id="element-19">
                    <UserManagementPage data-id="element-20" />
                  </Layout>
                </ProtectedRoute>} data-id="element-17" />
            <Route path="/tours" element={<ProtectedRoute allowedRoles={['ADMIN']} data-id="element-22">
                  <Layout data-id="element-23">
                    <TourManagementPage data-id="element-24" />
                  </Layout>
                </ProtectedRoute>} data-id="element-21" />

            {/* Driver Routes */}
            <Route path="/driver" element={<ProtectedRoute allowedRoles={['CHAUFFEUR']} data-id="element-26">
                  <Layout data-id="element-27">
                    <DriverDashboard data-id="element-28" />
                  </Layout>
                </ProtectedRoute>} data-id="element-25" />
            <Route path="/orders/:id/collect" element={<ProtectedRoute allowedRoles={['CHAUFFEUR']} data-id="element-30">
                  <Layout data-id="element-31">
                    <ConfirmCollectionPage data-id="element-32" />
                  </Layout>
                </ProtectedRoute>} data-id="element-29" />
            <Route path="/driver/tours" element={<ProtectedRoute allowedRoles={['CHAUFFEUR']} data-id="element-34">
                  <Layout data-id="element-35">
                    <DriverToursPage data-id="element-36" />
                  </Layout>
                </ProtectedRoute>} data-id="element-33" />
            <Route path="/driver/tours/:id" element={<ProtectedRoute allowedRoles={['CHAUFFEUR']} data-id="element-38">
                  <Layout data-id="element-39">
                    <DriverTourDetailPage data-id="element-40" />
                  </Layout>
                </ProtectedRoute>} data-id="element-37" />

            {/* Depot Routes */}
            <Route path="/depot" element={<ProtectedRoute allowedRoles={['DEPOT', 'ADMIN']} data-id="element-42">
                  <Layout data-id="element-43">
                    <DepotDashboard data-id="element-44" />
                  </Layout>
                </ProtectedRoute>} data-id="element-41" />
            <Route path="/depot/reception" element={<ProtectedRoute allowedRoles={['DEPOT', 'ADMIN']} data-id="element-46">
                  <Layout data-id="element-47">
                    <DepotReceptionPage data-id="element-48" />
                  </Layout>
                </ProtectedRoute>} data-id="element-45" />
            <Route path="/depot/cleaning" element={<ProtectedRoute allowedRoles={['DEPOT', 'ADMIN']} data-id="element-50">
                  <Layout data-id="element-51">
                    <CleaningManagementPage data-id="element-52" />
                  </Layout>
                </ProtectedRoute>} data-id="element-49" />
            <Route path="/depot/storage" element={<ProtectedRoute allowedRoles={['DEPOT', 'ADMIN']} data-id="element-54">
                  <Layout data-id="element-55">
                    <StorageAssignmentPage data-id="element-56" />
                  </Layout>
                </ProtectedRoute>} data-id="element-53" />

            {/* Shared Order Routes */}
            <Route path="/orders/:id" element={<ProtectedRoute data-id="element-58">
                  <Layout data-id="element-59">
                    <OrderDetailPage data-id="element-60" />
                  </Layout>
                </ProtectedRoute>} data-id="element-57" />
            <Route path="/orders" element={<ProtectedRoute data-id="element-62">
                  <Layout data-id="element-63">
                    <OrderListPage data-id="element-64" />
                  </Layout>
                </ProtectedRoute>} data-id="element-61" />
          </Routes>
        </Router>
      </OrderProvider>
    </AuthProvider>;
}